module.exports = __webpack_public_path__ + "img/Expo_Topic5.56cbc0cc.png";